<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'material/index' }">
                                Bahan Ajar
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            Kelas Bahan Ajar
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col mb-3">
                <h3>Kelas Bahan Ajar</h3>
            </div>
        </div>
        <div class="row">
            <div class="col px-4">
                <div class="row">
                    <div class="col-xl-2 col-md-3 col-sm-4 col-6 px-2 my-2" v-for="grade in grades">
                        <router-link v-bind:to="{name: 'material/subject', params: {gradeID: grade.id}}" class="btn btn-outline-danger btn-block font-weight-bold text-truncate">
                            {{ grade.name }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "MaterialIndex",
        data() {
            return {
                grades: []
            };
        },
        created() {
            this.axios.get(process.env.API_URL + '/grade').then(response => {
                this.grades = response.data.data;
            });
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/material/Index.vue